import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './nexgrow_v2';
import reportWebVitals from './reportWebVitals';

// Own scroll position ourselves. With the browser default ("auto") a reload of a
// deep-scrolled page briefly snaps to the top (empty #root has no height) and then
// jerks back down once React renders and the page grows tall again — the janky
// "loads, jumps up, then opens where I left off". The app already resets to the top
// on every route/mount (PageWrap + navigate), so we make that the single source of
// truth and stop the browser from fighting it.
if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

// Prerendered pages ship a static SEO body inside #root (see
// scripts/prerender-heads.mjs) so crawlers without JS get a real <h1> and
// crawlable links. createRoot() clears the container itself, but do it
// explicitly so the fallback can never survive into the mounted tree.
const container = document.getElementById('root');
container.innerHTML = '';

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
